import React from "react";
import { showLocalDate } from "../../utilities/functions";

const CreatedDate = ({ row }) => {
  return <div>{row.createdDate ? showLocalDate(row?.createdDate) : ""}</div>;
};

export default CreatedDate;
